import React, {forwardRef} from "react";

const TextareaInput = forwardRef(({
  onChange = null,
  onFocus = null,
  onBlur = null,
  onClick = null,
  validate = (e) => e,
  autoComplete = "on",
  label = null,
  placeholder = "",
  classes = "",
  refEl,
  id = `input-${Date.now()}`,
  shouldAutoFocus = false,
  name = "textarea-input",
  value = "",
  disabled = false,
  error = false,
  inputClass = "",
}, ref) => {
  return (
    <div className={`form-input textarea-input ${classes} ${error ? "form-input-error" : ""}`}>
      {label && (
        <label htmlFor={label.for} className={label.classes}>
          <span>{label.content}</span>
        </label>
      )}
      <span>
        <textarea
          placeholder={placeholder}
          className={inputClass}
          name={name}
          id={id}
          ref={refEl || ref}
          disabled={disabled}
          autoFocus={shouldAutoFocus}
          autoComplete={autoComplete}
          value={value || ""}
          onChange={(e) =>
            typeof onChange == "function"
              ? onChange(validate({ name: e.target.name, value: e.target.value }))
              : ""
          }
          onClick={(_e) => (typeof onClick == "function" ? onClick() : "")}
          onFocus={(_e) => (typeof onFocus == "function" ? onFocus() : "")}
          onBlur={(_e) => (typeof onBlur == "function" ? onBlur() : "")}
        />
        {label && <label htmlFor={label.for} className="animated-line"></label>}
      </span>
    </div>
  );
})

export default TextareaInput;
